import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@context/AuthContext";
import { FIRM_IMG_BASE } from "@config/env";

export default function FirmProfileTabs() {
  const { user, userSlug, switchFirmProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [busySlug, setBusySlug] = useState(null);
  const [error, setError] = useState("");

  const firms = Array.isArray(user?.firm_access_self_services) ? user.firm_access_self_services : [];

  if (String(user?.user_primary_role) !== "3" || firms.length < 2) return null;

  const activeFirm = firms.find(f => f.user_slug === userSlug);

  const onSelect = async (firm) => {
    if (busySlug || firm.user_slug === userSlug) return;
    setBusySlug(firm.user_slug);
    setError("");
    try {
      await switchFirmProfile(firm.user_slug);
      if (location.pathname.startsWith("/profile/")) {
        navigate(`/profile/${firm.user_slug}`, { replace: true });
      }
    } catch (e) {
      setError(e.message || "Unable to switch firm profile.");
    }
    setBusySlug(null);
  };

  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, color: "var(--fc-text-subtle)", marginBottom: 6 }}>
        You have a separate profile for each firm. Choose which one you are viewing or editing.
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", borderBottom: "1px solid var(--fc-border)" }}>
        {firms.map(f => {
          const active = f.user_slug === userSlug;
          const busy = busySlug === f.user_slug;
          return (
            <button
              key={f.user_slug}
              type="button"
              onClick={() => onSelect(f)}
              disabled={!!busySlug}
              style={{
                display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 14px",
                background: active ? "var(--fc-primary-light)" : "transparent",
                border: "none", borderBottom: `2px solid ${active ? "var(--fc-primary)" : "transparent"}`,
                marginBottom: -1, borderRadius: "8px 8px 0 0", cursor: active ? "default" : "pointer",
                fontFamily: "inherit", fontSize: 13, fontWeight: active ? 700 : 500,
                color: active ? "var(--fc-primary)" : "var(--fc-text-muted)",
                opacity: busySlug && !busy ? 0.6 : 1,
              }}
            >
              <span style={{ width: 20, height: 20, borderRadius: 6, background: "var(--fc-primary-light)", color: "var(--fc-primary)", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, overflow: "hidden", flexShrink: 0 }}>
                {f.firm_logo
                  ? <img src={FIRM_IMG_BASE + f.firm_logo} alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} onError={e => { e.target.style.display = "none"; }} />
                  : (f.firm_name || "?").charAt(0).toUpperCase()}
              </span>
              {f.firm_name}
              {busy && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: 11 }} />}
            </button>
          );
        })}
      </div>
      {activeFirm && (
        <div style={{ fontSize: 11.5, color: "var(--fc-text-muted)", background: "#FFFBEB", border: "1px solid #FDE68A", borderRadius: 8, padding: "7px 10px", marginTop: 10 }}>
          You are working on the profile shown to <b>{activeFirm.firm_name}</b> only. Changes do not affect your other firms.
        </div>
      )}
      {error && <div style={{ fontSize: 12, color: "var(--fc-danger, #DC2626)", marginTop: 8 }}>{error}</div>}
    </div>
  );
}
